export default "__VITE_ASSET__CWCqom1e__"